export const getProducts = async (
  {
    sortOrder,
    filterInput,
    range,
    startRowIndex,
    selectedFilters,
    selectedLanguage,
    // sessionData,
  },
  ctx
) => {
  try {
    const url = `${useURLs[NODE_ENV].PRODUCT_SEARCH_URL}?ctx=${ctx}`;
    const payload = JSON.stringify({
      prefix: filterInput,
      range: range,
      startRowIndex: startRowIndex,
      filters: selectedFilters,
      selectedLanguage,
      sortOrder: sortOrder,
      // sessionData,
    });

    const isAuthRequire = !!useCookie("isAuthenticated").value;
    const { data } = await useFetchApi(
      url,
      {
        key: `${payload}:auth-${isAuthRequire}`,
        method: "POST",
        body: payload,
        headers: {
          client_id: useURLs[NODE_ENV].CLIENT_ID,
          client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
          "Content-Type": "application/json",
        },
        retry: 1,
      },
      isAuthRequire
    );
    if (!data.value) {
      return { success: false };
    }
    const productsCount = data.value["count"];
    const pageCount = Math.ceil(productsCount / range);
    const products = data.value["products"];

    const attributeFilters = data.value["aggregations"];

    return {
      success: true,
      products,
      attributeFilters: attributeFilters,
      productsCount,
      pageCount,
    };
  } catch (error) {
    console.error("error getting products", error);
    return { success: false };
  }
};

// eslint-disable-next-line no-unused-vars
// export const getCategoryFilters = async ({ prefix, selectedLanguage }) => {
//   const url = useURLs[NODE_ENV].CATEGORY_FILTERS_URL;
//   const { data } = await useFetchApi(
//     `${url}?prefix=${prefix}&selectedLanguage=${selectedLanguage}`,
//     {
//       key: prefix,
//       method: "GET",
//       headers: {
//         client_id: useURLs[NODE_ENV].CLIENT_ID,
//         client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
//         "Content-Type": "application/json",
//       },
//       retry: 1,
//     },
//     false
//   );
//   return data;
// };

export const getSuggestions = async ({ keyword, chainId }) => {
  try {
    if (!keyword) {
      return [];
    }

    const url = useURLs[NODE_ENV].SUGGESTION_URL;
    const { data } = await useFetch(`${url}${keyword}&chainId=${chainId}`, {
      key: `autocomplete-${keyword}`,
      method: "GET",
      headers: {
        client_id: useURLs[NODE_ENV].CLIENT_ID,
        client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
        "Content-Type": "application/json",
      },
      retry: 1,
    });

    return data;
  } catch (error) {
    console.error("error getting suggestions", error);
    return [];
  }
};

export const findManyProductsByIds = async ({ ids = [], selectedLanguage }) => {
  if (!ids.length) {
    return;
  }

  const url = `${useURLs[NODE_ENV].PRODUCT_FIND_MANY_URL}?ids=${ids}`;
  const payload = JSON.stringify({
    ids: ids,
    selectedLanguage,
  });

  const isAuthRequire = !!useCookie("isAuthenticated").value;
  const { data } = await useFetchApi(
    url,
    {
      key: `${payload}:auth-${isAuthRequire}`,
      method: "POST",
      body: payload,
      headers: {
        client_id: useURLs[NODE_ENV].CLIENT_ID,
        client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
        "Content-Type": "application/json",
      },
      retry: 1,
    },
    isAuthRequire
  );
  return data;
};

// Ranked personalized article ids from the core API (nightly snapshot, identity from
// the JWT). Empty list = no history yet -> caller hides the carousel. Over-fetch on
// purpose: the Node search resolution drops ids the customer may not see/buy.
export const getRecommendedProductIds = async (count = 50) => {
  const isAuthenticated = useCookie("isAuthenticated").value;
  if (!isAuthenticated) {
    return [];
  }
  const url = `${useCldURLs[CLD_ENV].product.get_recommendations}?count=${count}`;
  try {
    const { data } = await useFetchApi(
      url,
      {
        // Per-user data behind a user-agnostic key would leak between logins in the
        // same app session — nonce the key so the async-data cache is never reused.
        // Cheap: the core API memory-caches the list per customer for 12h anyway.
        key: `get_recommended_product_ids-${count}-${Math.random().toString(36).slice(2)}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        retry: 1,
        server: false,
      },
      true
    );
    return data.value?.articleIds ?? [];
  } catch (error) {
    return [];
  }
};

// TODO HANDLE
export const getProductPreSalePercentage = async (id) => {
  const isAuthenticated = useCookie("isAuthenticated").value;
  if (!isAuthenticated) {
    return false;
  }
  const url = `${useCldURLs[CLD_ENV].product.get_pre_sale_percentage}?stockId=${id}`;
  try {
    const { data } = await useFetchApi(
      url,
      {
        key: `get_product_pre_sale_percentage-${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        retry: 1,
      },
      true
    );
    return data;
  } catch (error) {
    return -1;
  }
};

export const getReleaseProducts = async ({
  releaseFilters,
  startRowIndex,
  range,
  selectedLanguage,
  sortOrder,
}) => {
  try {
    const url = useURLs[NODE_ENV].PRODUCT_RELEASE_SEARCH_URL;
    const { data } = await useFetchApi(
      url,
      {
        key: JSON.stringify(releaseFilters),
        method: "POST",
        headers: {
          client_id: useURLs[NODE_ENV].CLIENT_ID,
          client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          releaseFilters,
          startRowIndex,
          range,
          selectedLanguage,
          sortOrder,
        }),

        retry: 1,
      },
      false
    );

    const productsCount = data.value["count"];
    const pageCount = Math.ceil(productsCount / range);
    const products = data.value["products"];
    const attributeFilters = data.value["aggregations"];

    return {
      success: true,
      products,
      attributeFilters: attributeFilters,
      productsCount,
      pageCount,
    };
  } catch (error) {
    console.error("error getting products", error);
    return { success: false };
  }
};

export const getAllFutureReleaseProducts = async ({
  releaseFilters,
  startRowIndex,
  range,
  selectedLanguage,
  sortOrder,
}) => {
  try {
    const url = useURLs[NODE_ENV].PRODUCT_ALL_FUTURE_RELEASE_SEARCH_URL;
    const { data } = await useFetchApi(
      url,
      {
        key: JSON.stringify(releaseFilters),
        method: "POST",
        headers: {
          client_id: useURLs[NODE_ENV].CLIENT_ID,
          client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          releaseFilters,
          startRowIndex,
          range,
          selectedLanguage,
          sortOrder,
        }),

        retry: 1,
      },
      false
    );

    const productsCount = data.value["count"];
    const pageCount = Math.ceil(productsCount / range);
    const products = data.value["products"];
    const attributeFilters = data.value["aggregations"];

    return {
      success: true,
      products,
      attributeFilters: attributeFilters,
      productsCount,
      pageCount,
    };
  } catch (error) {
    console.error("error getting products", error);
    return { success: false };
  }
};
